import { render, staticRenderFns } from "./IconsPage.vue?vue&type=template&id=38a07845&scoped=true&"
import script from "./IconsPage.vue?vue&type=script&lang=ts&"
export * from "./IconsPage.vue?vue&type=script&lang=ts&"
import style0 from "./IconsPage.vue?vue&type=style&index=0&id=38a07845&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a07845",
  null
  
)

export default component.exports